import { render, staticRenderFns } from "./RecentSimulations.vue?vue&type=template&id=8dbc80ca"
import script from "./RecentSimulations.vue?vue&type=script&lang=js"
export * from "./RecentSimulations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports